import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import * as FiIcons from 'react-icons/fi'
import SafeIcon from '../../common/SafeIcon'

const { FiMenu, FiLogOut, FiHome, FiCopy, FiUpload, FiEye, FiSettings } = FiIcons

const AdminLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = React.useState(false)
  const { logout, user } = useAuth()
  const location = useLocation()

  const navigation = [
    { name: 'Gestión de Platos', href: '/admin/dashboard', icon: FiHome },
    { name: 'Clonar Menú', href: '/admin/clone', icon: FiCopy },
    { name: 'Carga CSV', href: '/admin/upload', icon: FiUpload },
    { name: 'Configuración', href: '/admin/config', icon: FiSettings },
  ]

  const handleLogout = () => {
    logout()
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Mobile sidebar backdrop */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden" 
          onClick={() => setSidebarOpen(false)} 
        />
      )}

      {/* Sidebar */}
      <div className={`fixed inset-y-0 left-0 z-50 w-64 bg-white shadow-lg transform transition-transform duration-300 ease-in-out lg:translate-x-0 ${
        sidebarOpen ? 'translate-x-0' : '-translate-x-full'
      }`}>
        <div className="flex flex-col h-full">
          {/* Logo */}
          <div className="flex items-center justify-center h-16 border-b border-gray-200">
            <h1 className="text-xl font-bold text-vip-orange">VIP – BAR Admin</h1>
          </div>

          {/* Navigation */}
          <nav className="flex-1 px-4 py-6 space-y-2">
            {navigation.map((item) => {
              const isActive = location.pathname === item.href
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`flex items-center px-4 py-2 text-sm font-medium rounded-md transition-colors duration-200 ${
                    isActive 
                      ? 'bg-vip-orange text-white' 
                      : 'text-vip-brown hover:bg-gray-100'
                  }`}
                  onClick={() => setSidebarOpen(false)}
                >
                  <SafeIcon icon={item.icon} className="mr-3 h-5 w-5" />
                  {item.name}
                </Link>
              )
            })}
          </nav>

          {/* User info and logout */}
          <div className="border-t border-gray-200 p-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <div className="w-8 h-8 bg-vip-orange rounded-full flex items-center justify-center">
                  <span className="text-white text-sm font-medium">
                    {user?.email?.charAt(0).toUpperCase()}
                  </span>
                </div>
                <div className="ml-3">
                  <p className="text-sm font-medium text-vip-brown truncate">
                    {user?.email}
                  </p>
                </div>
              </div>
              <button
                onClick={handleLogout}
                className="p-2 text-gray-400 hover:text-vip-dark transition-colors duration-200"
                title="Cerrar sesión"
              >
                <SafeIcon icon={FiLogOut} className="h-5 w-5" />
              </button>
            </div>
            <div className="mt-3 pt-3 border-t border-gray-200">
              <Link
                to="/menu/hoy"
                target="_blank"
                className="flex items-center text-sm text-vip-brown hover:text-vip-dark transition-colors duration-200"
              >
                <SafeIcon icon={FiEye} className="mr-2 h-4 w-4" />
                Ver menú público
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Main content */}
      <div className="lg:pl-64">
        {/* Top bar */}
        <div className="sticky top-0 z-40 flex h-16 bg-white shadow-sm border-b border-gray-200">
          <button
            type="button"
            className="px-4 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-vip-orange lg:hidden"
            onClick={() => setSidebarOpen(true)}
          >
            <SafeIcon icon={FiMenu} className="h-6 w-6" />
          </button>
          <div className="flex-1 flex justify-between items-center px-4">
            <h2 className="text-lg font-semibold text-vip-brown">
              Panel de Administración
            </h2>
          </div>
        </div>

        {/* Page content */}
        <main className="p-6">
          {children}
        </main>
      </div>
    </div>
  )
}

export default AdminLayout